const steps = [
  {
    step: "01",
    title: "Discover Products",
    description: "Browse through organized spreadsheet listings to find products across multiple categories. The structured format lets you scan dozens of items quickly without endless scrolling or clicking through individual product pages.",
    icon: "ri-search-eye-line",
  },
  {
    step: "02",
    title: "Compare Information",
    description: "Use the side-by-side layout to compare product details, pricing, sizing options, and availability. Make informed decisions with all the key information presented in one consolidated view.",
    icon: "ri-scales-3-line",
  },
  {
    step: "03",
    title: "Review Quality",
    description: "Check detailed product descriptions, material information, and category-specific details. The spreadsheet format makes it easy to assess quality indicators before making a purchase decision.",
    icon: "ri-shield-check-line",
  },
  {
    step: "04",
    title: "Make Better Decisions",
    description: "With all the research completed in one organized resource, you can confidently select the products that best match your needs, style preferences, and budget requirements.",
    icon: "ri-emotion-happy-line",
  },
];

export default function HowItWorks() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            How It Works
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            How <span className="text-primary-500">Spreadsheet Research</span> Works
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Four simple steps to smarter, more efficient product discovery
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {steps.map((s, i) => (
            <div key={s.step} className="relative group">
              {/* Step Connector Line */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[calc(100%-2rem)] h-px bg-background-200">
                  <div className="absolute right-0 -top-1 w-2 h-2 rounded-full bg-accent-400"></div>
                </div>
              )}

              <div className="relative z-10 flex flex-col items-center text-center p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-300">
                <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                  <i className={`${s.icon} text-accent-600 text-xl`}></i>
                </div>
                <span className="text-xs font-bold text-accent-500 mb-2">STEP {s.step}</span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{s.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{s.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}